<template>
  <section class="volunteer-page-section wf-section">
    <div class="volunteer-page-container">
      <div class="volunteer-page-header">
        <h1 class="volunteer-page-title">
          <span class="volunteer-page-highlight">Volunteer</span>
        </h1>
        <p class="volunteer-page-subtitle" v-html="highlightText('Please fill the form according to your relevant region and field of work.', $store.state.searchQuery)">
        </p>
      </div>

      <div class="volunteer-page-forms">
        <!-- First Form - UK Based -->
        <div id="uk-volunteers" class="volunteer-page-card">
          <div class="volunteer-page-card-header">
            <h3 class="volunteer-page-card-title" v-html="highlightText('UK Volunteers', $store.state.searchQuery)"></h3>
            <p class="volunteer-page-card-description" v-html="highlightText('Fill this form if you are based in the UK.', $store.state.searchQuery)"></p>
          </div>
          <div class="volunteer-page-card-actions">
            <a 
              href="https://docs.google.com/forms/d/1hdwJ8uZZRgH-aIn3mU2jJxTFy7T9MESfhDPu5QITjQA/edit" 
              target="_blank" 
              class="volunteer-page-button"
            >
              Fill UK Form
            </a>
          </div>
        </div>

        <!-- Second Form - Non-UK Based -->
        <div id="international-volunteers" class="volunteer-page-card">
          <div class="volunteer-page-card-header">
            <h3 class="volunteer-page-card-title" v-html="highlightText('International Volunteers', $store.state.searchQuery)"></h3>
            <p class="volunteer-page-card-description" v-html="highlightText('Fill this form if you are NOT based in UK.', $store.state.searchQuery)"></p>
          </div>
          <div class="volunteer-page-card-actions">
            <a 
              href="https://docs.google.com/forms/d/e/1FAIpQLSfG6U8jDcDS2Ssq1WJDKYiiucGlP3fxK84nkS0vb7fKt-iLcA/viewform" 
              target="_blank" 
              class="volunteer-page-button"
            >
              Fill International Form
            </a>
          </div>
        </div>

        <!-- Third Form - Legal Team -->
        <div id="legal-team" class="volunteer-page-card">
          <div class="volunteer-page-card-header">
            <h3 class="volunteer-page-card-title" v-html="highlightText('Legal Team Support', $store.state.searchQuery)"></h3>
            <p class="volunteer-page-card-description" v-html="highlightText('If you want to be part of Clive Smith\'s legal team, fill this form.', $store.state.searchQuery)">
            </p>
            <p class="volunteer-page-card-requirements" v-html="highlightText('This is ONLY for people belonging from the following fields:<br>Medical professional, Imam, journalist, professional translator (English to Arabic), military, marketing, expertise in prison conditions.', $store.state.searchQuery)">
            </p>
          </div>
          <div class="volunteer-page-card-actions">
            <a 
              href="https://docs.google.com/forms/d/1wDXzCXWETcgenA2P5cl5qMgfH4gs6nmTyhWZuaaRSpM/edit" 
              target="_blank" 
              class="volunteer-page-button"
            >
              Fill Legal Team Form
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Volunteer",
  methods: {
    highlightText(text, query) {
      if (!text || !query || !query.trim()) {
        return text || '';
      }
      
      const searchQuery = query.trim();
      
      // Split query into words for better matching
      const queryWords = searchQuery.split(/\s+/).filter(word => word.length > 0);
      
      // Handle HTML content - preserve HTML tags but highlight text
      let result = text;
      
      // First, temporarily replace HTML tags with placeholders
      const htmlTags = [];
      let tagIndex = 0;
      result = result.replace(/<[^>]+>/g, (match) => {
        htmlTags[tagIndex] = match;
        return `__HTML_TAG_${tagIndex++}__`;
      });
      
      // Now escape HTML entities
      result = result.replace(/&/g, '&amp;');
      
      // Highlight each query word
      queryWords.forEach(word => {
        if (word.length > 2) { // Only highlight words longer than 2 characters
          const escapedWord = this.escapeRegex(word);
          const regex = new RegExp(`(${escapedWord})`, 'gi');
          result = result.replace(regex, '<mark class="search-highlight">$1</mark>');
        }
      });
      
      // Also highlight the full query if it's longer
      if (searchQuery.length > 3) {
        const escapedQuery = this.escapeRegex(searchQuery);
        const fullRegex = new RegExp(`(${escapedQuery})`, 'gi');
        // Only replace if not already highlighted
        result = result.replace(fullRegex, (match, p1) => {
          if (!match.includes('search-highlight')) {
            return `<mark class="search-highlight">${p1}</mark>`;
          }
          return match;
        });
      }
      
      // Restore HTML tags
      htmlTags.forEach((tag, index) => {
        result = result.replace(`__HTML_TAG_${index}__`, tag);
      });
      
      return result;
    },
    escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
  },
};
</script>

<style scoped>
.volunteer-page-section {
  padding: 60px 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 80vh;
}

.volunteer-page-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.volunteer-page-header {
  text-align: center;
  margin-bottom: 50px;
}

.volunteer-page-title {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 20px;
  color: #2c3e50;
  text-align: center;
  letter-spacing: -0.5px;
}

.volunteer-page-highlight {
  color: #27ae60;
  position: relative;
}

.volunteer-page-highlight::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #27ae60, #2ecc71);
  border-radius: 2px;
}

.volunteer-page-subtitle {
  font-size: 1.2rem;
  color: #6c757d;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
  font-weight: 400;
}

.volunteer-page-forms {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  max-width: 1100px;
  margin: 0 auto;
}

.volunteer-page-card {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(39, 174, 96, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.volunteer-page-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #27ae60, #2ecc71);
}

.volunteer-page-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border-color: #27ae60;
}

.volunteer-page-card-header {
  margin-bottom: 25px;
}

.volunteer-page-card-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 12px;
  line-height: 1.3;
}

.volunteer-page-card-description {
  font-size: 1rem;
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 15px;
}

.volunteer-page-card-requirements {
  font-size: 0.9rem;
  color: #495057;
  line-height: 1.5;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #27ae60;
  margin-top: 15px;
  font-weight: 500;
}

.volunteer-page-card-actions {
  text-align: center;
  margin-top: 20px;
}

.volunteer-page-button {
  display: inline-block;
  padding: 14px 32px;
  background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(39, 174, 96, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.volunteer-page-button:hover {
  background: linear-gradient(135deg, #219a52 0%, #27ae60 100%);
  color: white;
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(39, 174, 96, 0.4);
}

/* Responsive Design */
@media (max-width: 768px) {
  .volunteer-page-forms {
    grid-template-columns: 1fr;
    gap: 25px;
  }
  
  .volunteer-page-card {
    padding: 25px;
  }
  
  .volunteer-page-title {
    font-size: 2.5rem;
  }
  
  .volunteer-page-subtitle {
    font-size: 1.1rem;
  }
  
  .volunteer-page-section {
    padding: 40px 0;
  }
}

@media (max-width: 480px) {
  .volunteer-page-container {
    padding: 0 15px;
  }
  
  .volunteer-page-section {
    padding: 30px 0;
  }
  
  .volunteer-page-card {
    padding: 20px;
  }
  
  .volunteer-page-title {
    font-size: 2rem;
  }
  
  .volunteer-page-button {
    padding: 12px 24px;
    font-size: 0.9rem;
  }
}

/* Search highlight styling */
:deep(.search-highlight) {
  background-color: #198754;
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(25, 135, 84, 0.3);
  display: inline-block;
}
</style>
